import { useRef, useEffect, useCallback } from 'react'

const useBeforeUnload = (active = true, message = '') => {
  const handlerRef = useRef(null)

  const cleanup = useCallback(() => {
    if (handlerRef.current) {
      window.removeEventListener('beforeunload', handlerRef.current)
      handlerRef.current = null
    }
  }, [])

  useEffect(() => {
    if (active) {
      handlerRef.current = (event) => {
        event.preventDefault()
        event.returnValue = message || ''
      }
      
      window.addEventListener('beforeunload', handlerRef.current)
    } else {
        cleanup()
      }

    return () => {
        cleanup()
    }
  }, [active, message])

  return {cleanup}
}

export default useBeforeUnload 